var $1101246e8c7d9357$exports = {};
$1101246e8c7d9357$exports = {
  "buttonLabel": "N\xE4yt\xE4 ehdotukset",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " vaihtoehto");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " vaihtoehdot");
      }
    }), " saatavilla.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Mentiin ryhm\xE4\xE4n ".concat(args.groupTitle, ", ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " vaihtoehdon");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " vaihtoehdon");
          }
        }), " kanssa.");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", valittu",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Ehdotukset",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", valittu");
  }
};
export { $1101246e8c7d9357$exports as default };